module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"hotlist_status":"Hotlist Status 🔥","statuses":{"active":{"label":"Aktiv","description":"Unternehmen können dich mit deinem anonymisierten Profil finden und direkt zum Interview einladen"},"deactive":{"label":"Deaktiviert","description":"Um wieder von Unternehmen anonym gefunden zu werden, passe deinen Hotlist-Status an"}}}}')
  delete Component.options._Ctor
}
